@if ((loadingTranslations$ | async) === false) {
  <router-outlet></router-outlet>
}
